module.exports = __webpack_public_path__ + "static/media/vasita.bf0ac784.png";